import React, { useState, useRef, useCallback } from 'react'

import PropTypes from 'prop-types'

import isEmpty from 'lodash/isEmpty'
import toLower from 'lodash/toLower'

import { useDialog } from '@galo-monitor/dialog'
import I18n, { useT } from '@galo-monitor/i18n'
import Button from '@galo-monitor/web-components/Button'
import Modal from '@galo-monitor/web-components/Modal'
import RoleModulesForm from '@galo-monitor/web-containers/forms/company/RoleModulesForm'
import ErrorModal from '@galo-monitor/web-containers/modals/ErrorModal'

const RoleModulesModal = (props) => {
  const {
    id,
    open,
    handleClose,
    role,
    onSuccess
  } = props

  const [loading, setLoading] = useState(false)

  const t = useT()
  const { createDialog } = useDialog()

  const formRef = useRef(null)

  const handleConfirm = useCallback(
    () => {
      formRef.current.submit()
    },
    [formRef]
  )

  const handleSuccess = useCallback(
    () => {
      handleClose()
      onSuccess()
    },
    [handleClose, onSuccess]
  )

  const onError = useCallback(
    err => {
      setLoading(false)
      createDialog({
        id: 'error-role-modules',
        Component: ErrorModal,
        props: {
          title: `${ t('could not {action} the {this}', {
            howMany: 1,
            gender: 'male',
            action: toLower(t(isEmpty(role) ? 'register' : 'update')),
            this: toLower(t('role', { howMany: 1 }))
          })  }.`,
          message: t(err?.response?.data?.message || 'unexpected error occurred')
        }
      })
    },
    [createDialog, role, t]
  )

  return (
    <Modal
      id={ id }
      open={ open }
      loading={ loading }
      title={ t('managing {this} permissions', { this: t('role', { howMany: 1 }) }) }
      subTitle={ role.name }
      fullWidth
      maxWidth="md"
      FooterComponent={ () => (
        <>
          <Button
            id="save"
            onClick={ handleConfirm }
          >
            <I18n>save</I18n>
          </Button>
        </>
      ) }
    >
      <RoleModulesForm
        ref={ formRef }
        role={ role }
        onSuccess={ handleSuccess }
        onError={ onError }
        loading={ loading }
        setLoading={ setLoading }
      />
    </Modal>
  )
}

RoleModulesModal.propTypes = {
  id: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  role: PropTypes.object.isRequired
}

export default RoleModulesModal
